import { useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "../../shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  InputType,
  SelectFilter,
} from "../../shared/filters/types/filter";

const PERIOD_ID = "period";

export function usePeriodFilter(): SelectFilter {
  const { t } = useTranslation();
  const defaultValue = { filterId: PERIOD_ID, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: PERIOD_ID,
      title: t("periodString"),
      options: [
        {
          value: "custom",
          title: t("customPeriodString"),
          startDate: "",
          endDate: "",
        },
      ],
      enabled: true,
      defaultValue,
      showCustomPeriodInDropdown: true,
    },
    t("allDatesString")
  );
}
